<template>
    <div class="maskbg">
        <div class="dialog jqg">
            <div class="close" @click="handleClose"></div>
            <div class="flx-bs">
                <div class="left">
                    <div class="main img"><img :src="imageUrl"/></div>
                    <ul class="flx-bc btnBox">
                        <li class="btn" :class="item.videoUrl===videoUrl?'active':''" v-for="(item,index) in videos" :key="index" @click="change(item)">{{item.name}}</li>
                    </ul>
                </div>
                <div class="main right">
                    <video class="video" controls :src="videoUrl" :key="videoUrl"></video>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    components: {},
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        videos: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            imageUrl: '',
            videoUrl: '',
        }
    },
    created() {
        this.imageUrl = this.videos[0].imageUrl
        this.videoUrl = this.videos[0].videoUrl
    },
    mounted() {
    },
    methods: {
        change(val){
            this.videoUrl = val.videoUrl
            this.imageUrl = val.imageUrl
        },
        handleClose(){
            this.$emit('update:visible', false)
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/common';
@import '@/styles/dialog';
</style>